/**
 * IA Canon v2 (IA_CANON_v2_2026-07-04.md разделы 1 и 4) — резолвер Фокус-слота.
 *
 * 5-й слот bottom-nav адаптивен по фазе сезона, стабильный смысл —
 * «мой следующий шаг к старту»:
 *   нет активной цели      → events (Старты — discovery)
 *   цель активна           → plan   (План — подготовка)
 *   race week (0..7 дней)  → race   (Гонка — RaceCenter takeover)
 *
 * Пост-гоночная фаза (recap, T+5) — W-IA-6, сюда не входит.
 * Pure function: вся логика дат через явный todayISO — тестируется без моков.
 */

export type FocusPhase = "events" | "plan" | "race";

export interface FocusTabInput {
  goalType: string | null | undefined;
  raceDateISO: string | null | undefined;
  goalStatus: string | null | undefined;
  todayISO: string;
}

const INACTIVE_STATUSES = new Set(["completed", "failed", "cancelled"]);
const RACE_WEEK_DAYS = 7;
const POST_RACE_DAYS = 3;

export function resolveFocusPhase(input: FocusTabInput): FocusPhase {
  const { goalType, raceDateISO, goalStatus, todayISO } = input;

  const hasActiveGoal =
    !!raceDateISO && !INACTIVE_STATUSES.has(goalStatus ?? "");

  if (!hasActiveGoal) return "events";

  if (goalType === "race") {
    const days = daysBetweenISO(todayISO, raceDateISO);
    // W-IA-6: окно включает T+3 после гонки — слот держит «Гонка»
    // (RaceCenter recap-tab), потом возвращается к План/Старты.
    if (days !== null && days >= -POST_RACE_DAYS && days <= RACE_WEEK_DAYS) {
      return "race";
    }
  }

  return "plan";
}

function daysBetweenISO(fromISO: string, toISO: string): number | null {
  const from = Date.parse(fromISO);
  const to = Date.parse(toISO);
  if (Number.isNaN(from) || Number.isNaN(to)) return null;
  return Math.round((to - from) / 86_400_000);
}
